// extracted by mini-css-extract-plugin
export var auto = "_2j-1";
export var spinner = "_2j-0";